import React, { ButtonHTMLAttributes, FC, useState } from 'react'
import styled from 'styled-components'
import RoundButton from '../Buttons/RoundButton'
import Icon, { IconSize } from '../Icon/Icon'
import { IconName } from '../Icon/IconName'
import { pulseAnimation } from './styles'

interface IWishButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  filled?: boolean
  grey?: boolean
  white?: boolean
  large?: boolean
}

const StyledIcon = styled(Icon)<{ shouldPulse: boolean }>`
  ${({ shouldPulse }) => (shouldPulse ? pulseAnimation : '')};
  display: block;
`

const StyledButton = styled(RoundButton)`
  background: transparent;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`

function getHeartAsset({
  filled,
  grey,
  white,
}: {
  filled?: boolean
  grey?: boolean
  white?: boolean
}) {
  if (filled) {
    if (grey) {
      return IconName.IcWishlistGrey
    }
    if (white) {
      return IconName.IcWishlistWhite
    }

    return IconName.IcWishlist
  } else {
    if (grey) {
      return IconName.IcWishlistEmptyGrey
    }
    if (white) {
      return IconName.IcWishlistEmptyWhite
    }

    return IconName.IcWishlistEmpty
  }
}

const WishButton: FC<IWishButtonProps> = ({
  filled = false,
  grey = false,
  white = false,
  large = false,
  onClick = () => undefined,
  ...buttonProps
}) => {
  const [shouldPulse, setShouldPulse] = useState(false)
  const heartAsset = getHeartAsset({ filled, grey, white })

  return (
    <StyledButton
      data-testid={filled ? 'WishListButton_Filled' : 'WishListButton'}
      onClick={event => {
        onClick(event)
        setShouldPulse(false)
      }}
      onMouseEnter={() => setShouldPulse(true)}
      onMouseLeave={() => setShouldPulse(false)}
      {...buttonProps}
    >
      <StyledIcon
        data-testid="WishListIcon"
        size={large ? IconSize.M : IconSize.S}
        shouldPulse={shouldPulse}
        asset={heartAsset}
      />
    </StyledButton>
  )
}

export default WishButton
